// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonGroup_style_wrapper__hzG7D","buttons":"ButtonGroup_style_buttons__vQCWf","btnFull":"ButtonGroup_style_btnFull__Q7KD4","rotate":"ButtonGroup_style_rotate__1wR3r"};